import { apiClient } from './ApiClient';
import { API_ENDPOINTS } from '../../shared/constants';
import { ApiResponse, PaymentSaleRequest, PaymentSaleResponseData } from '../../shared/types';

export interface PaymentResult {
    authorization: string;
    document: string;
    clientReceipt: string;
    establishmentReceipt: string;
}

export class PaymentApi {
    static async processSale(
        requestData: PaymentSaleRequest,
        token: string
    ): Promise<PaymentResult> {
        const response = await apiClient.post<ApiResponse<PaymentSaleResponseData>>(
            API_ENDPOINTS.paymentSale,
            requestData,
            token
        );

        if (!response.success || !response.data) {
            throw new Error(response.message || 'Failed to process payment');
        }

        return {
            authorization: response.data.autorizacao,
            document: response.data.documento,
            clientReceipt: response.data.comprovanteCliente,
            establishmentReceipt: response.data.comprovanteEstabelecimento,
        };
    }
}

